module.exports = __webpack_public_path__ + "static/media/banner11.09db07e4.jpg";